import { useCallback, useRef } from 'react';

/**
 * Makes a whole video card a mouse target for its Watch control while the
 * Watch button stays the single keyboard and screen-reader control.
 *
 * The card's onClick fires for clicks anywhere on it, including the Watch
 * button itself (its click bubbles up). Links inside the card (Read the
 * guide) are skipped. Attach watchRef to the element wrapping the Watch
 * button. Before opening, focus is moved to the Watch button so
 * the dialog returns focus there when it closes, even when the click landed
 * on the thumbnail.
 *
 * @param {Object} video
 * @param {(video: Object) => void} onWatch
 */
export default function useCardWatch(video, onWatch) {
  const watchRef = useRef(null);

  const onCardClick = useCallback((event) => {
    if (event.target instanceof Element && event.target.closest('a')) return;
    watchRef.current?.querySelector('button')?.focus();
    onWatch(video);
  }, [video, onWatch]);

  return { watchRef, onCardClick };
}
